import { Component, OnInit, ViewChild } from '@angular/core';
import { GoogleMap, MapInfoWindow, MapMarker } from '@angular/google-maps';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable, count } from 'rxjs';
import { AllSthanLocation, Cities, Geolocations, SthandarshanService, Talukas, Villages } from './sthandarshan.service';

@Component({
  selector: 'app-sthandarshan',
  templateUrl: './sthandarshan.component.html',
  styleUrls: ['./sthandarshan.component.css']
})
export class SthandarshanComponent implements OnInit {
  constructor(public sanitizer: DomSanitizer, private sthandarshanService: SthandarshanService) {
    sthandarshanService.get().subscribe(x=> {
      this.cities = x.cities;
      this.talukas = x.talukas;
      this.geolocations = x.geolocations;
      this.villages = x.villages;
    });
  }

  @ViewChild('myGoogleMap', { static: false })
  map!: GoogleMap;
  @ViewChild(MapInfoWindow, { static: false })
  info!: MapInfoWindow;

  zoom = 12;
  cities : Cities[] = []
  talukas : Talukas[] = []
  villages :Villages[] = []
  geolocations: Geolocations[] = []

  filteredtalukas : Talukas[] = []
  filteredvillages :Villages[] = []
  filteredgeolocations: Geolocations[] = []

  refreshTaluka(id:any)
  {
    console.log(id);
    this.filteredvillages = [];
    this.filteredtalukas = this.talukas.filter(x=>x.cityid == id);
  }

  refreshVillage(id:any)
  {
    console.log(id);
    this.filteredvillages = this.villages.filter(x=>x.talukaid == id);
  }

  center!: google.maps.LatLngLiteral;
  options: google.maps.MapOptions = {
    zoomControl: true,
    scrollwheel: false,
    disableDoubleClickZoom: true,
    mapTypeId: 'hybrid',
    // maxZoom:this.maxZoom,
    // minZoom:this.minZoom,
  }
  markers = [] as any;
  infoContent = ''

  eventHandler(event: any, name: string) {
    console.log(event, name);

    // Add marker on double click event
    if (name === 'mapDblclick') {
      //this.dropMarker(event)
    }
  }

  // Markers
  logCenter() {


  }

  dropMarker(latLnt: string, latLng: string) {
    this.markers.push({
      position: {
        lat: Number(latLnt),
        lng: Number(latLng),
      },
      // label: {
      //   color: 'blue',
      //   text: 'Marker label ' + (this.markers.length + 1),
      // },
      title: 'Marker title ' + (this.markers.length + 1),
      info: 'Marker info ' + (this.markers.length + 1),
      options: {
        animation: google.maps.Animation.DROP
      }
    });


    this.center = {
      lat: Number(latLnt),
      lng: Number(latLng),
    }

    // var bounds = new google.maps.LatLngBounds();
    // for (var i = 0; i < this.markers?.length; i++) {
    //   bounds.extend(this.markers[i]);
    // }

    // this.map.fitBounds(bounds);

    // navigator.geolocation.getCurrentPosition((position) => {
    //   this.center = {
    //     lat: position.coords.latitude,
    //     lng: position.coords.longitude,
    //   }
    // })



  }

  changeMapZoom(e: any): any {
    this.zoom = e;
  }

  openInfo(marker: MapMarker, content: string) {
    this.infoContent = content;
    this.info.open(marker)
  }


  ngOnInit(): void {

    this.dropMarker("20.16659707", "77.96117156");

  }

  keyword = 'name';
  data = [
    {
      id: 1,
      name: 'Georgia'
    },
     {
       id: 2,
       name: 'Usa'
     },
     {
       id: 3,
       name: 'England'
     },
     {
      id: 4,
      name: 'England2'
    }
  ];


  selectEvent(item:any) {
    // do something with selected item
  }

  onChangeSearch(val: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }
  
  onFocused(e:any){
    // do something when input is focused
  }

}
